/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Link, Script } from 'gatsby';
import type { FC } from 'react';
import FooterLinks from './links';

const Footer: FC = () => {
  return (
    <div>
      <footer className="footer-bg">
        <div className="fcbg fcbgTop" />

        <div className="container mx-auto px-6">
          <FooterLinks />

          {/* Uncomment and modify the sections below if needed */}
          {/* 
        <div
          className="flex md:flex-row flex-col justify-between items-center gap-2 w-full pb-6
         text-gray-50 font-light text-sm"
        >
          <p>
            Designed and Developed By{' '}
            <a
              className="font-semibold"
              href="https://www.zartek.in"
              rel="noreferrer"
              target="_blank"
            >
              Zartek
            </a>
          </p>
        </div>

        <hr className="my-6 opacity-30" />
        <div className="flex justify-center pb-6 text-gray-50 font-light">
          <a
            className="text-gray-50 transition-smooth hover:text-gray-200"
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaTwitter />
          </a>
          <a
            className="text-gray-50 transition-smooth hover:text-gray-200"
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaYoutube />
          </a>
        </div>
        */}
        </div>
        <div className="footer-bottom fcbg text-gray-50 font-light text-sm py-3">
          <div className="container mx-auto px-6">
            <div className="grid lg:grid-cols-2 lg:gap-2 gap-6 space-x-0 md:space-x-4">
              <Link
                className="text-gray-50 transition-smooth hover:text-gray-200 text-left"
                to="/terms-and-conditions"
              >
                Terms & Conditions
              </Link>
              <p className="text-right max-sm:ml-0 max-sm:text-left">
                © Copyright {new Date().getFullYear()}. Sahil Alloys & Machine
                Tools
              </p>
            </div>
          </div>
        </div>
      </footer>
      {/* LinkedIn Insight Tag */}
      <Script>
        {`
            _linkedin_partner_id = "7006114";
            window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
            window._linkedin_data_partner_ids.push(_linkedin_partner_id);
          `}
      </Script>
      <Script src="https://snap.licdn.com/li.lms-analytics/insight.min.js" />
      <noscript>
        <img
          alt=""
          height="1"
          src="https://px.ads.linkedin.com/collect/?pid=7006114&fmt=gif"
          style={{ display: 'none' }}
          width="1"
        />
      </noscript>
    </div>
  );
};

export default Footer;
